/**
 * Format a URL for display
 * Shortens long URLs to domain/path or just "Link"
 */
export const formatUrl = (url: string, maxLength = 30): string => {
    if (!url) return '';

    try {
        const urlObj = new URL(url);
        const domain = urlObj.hostname.replace('www.', '');
        const path = urlObj.pathname === '/' ? '' : urlObj.pathname;

        // If it's a very long obscure URL, just return domain
        if (url.length > maxLength) {
            // If path is short, show domain + path
            if (path.length < 10) {
                return `${domain}${path}`;
            }
            return `${domain}/...`;
        }

        return `${domain}${path}`;
    } catch (e) {
        if (url.length > maxLength) {
            return `${url.substring(0, maxLength)}...`;
        }
        return url;
    }
};
